const getLateraMenuOpen = (state) => state.isLateralMenuOpen;

export default {
  getLateraMenuOpen,
};
